<div class="error-dialog-container">   
    <div class="error-dialog">
        <mat-dialog-content class="content"> 
            <div class="message">
                {{ data.message }}
            </div>
            <textarea class="detail" disabled>{{ data.detail }}</textarea>
            
        </mat-dialog-content>
        <mat-dialog-actions class="close-button">
            <button mat-raised-button (click)="refresh()" color="warn">Reset</button>
        </mat-dialog-actions>
    </div>

    
</div>